export default __webpack_public_path__ + "static/media/kramer_on.3c45b6a8.png";